<template>
  <div>
    <wc-data-box hideToolbar>
      <v-data-table
        dense
        :items='inquiries'
        :headers='headers'
        :search='search'
        item-key="index"
        @click:row='openInquiry'
        sort-by='date_created'
        sort-desc
      >
        
        <template v-slot:item.date_created='{ item }'>
          {{ item.date_created | shortDate }}
        </template>
        <template v-slot:item.last_name='{ item }'>
          {{ item.name }} {{ item.last_name }}
        </template>
        <template v-slot:item.division='{ item }'>
          <wc-div v-if='item.division' :division_obj='item.division_obj'></wc-div>
        </template>
        <template v-slot:item.created_by='{ item }'>
          {{ item.created_by_obj.name_display }}
        </template>
        <template v-slot:item.status='{ item }'>
          <wc-estimate-generated v-if='item.estimate_generated'></wc-estimate-generated>
          <wc-archived class='ml-2' v-if='item.archived'></wc-archived>
          <span v-if='!item.estimate_generated && !item.archived'>{{ item.status }}</span>
        </template>
      </v-data-table>
    </wc-data-box>
  </div>
</template>

<script>
import WCDivisionNAI from '@/components/misc/WCDivisionNAI'
import WCEstimateGenerated from '@/components/chips/WCEstimateGenerated'
import WCArchivedChip from '@/components/chips/WCArchivedChip'

export default {
  name: 'inquiries-table',
  props: {
    inquiries: {
      required: true
    },
    search: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    headers: [
      { text: 'Inquiry Date', value: 'date_created'},
      { text: 'Created By', value: 'created_by'},
      { text: 'Division', value: 'division'},
      { text: 'Contact', value: 'last_name'},
      { text: 'Assigned To', value: 'assigned_to_obj.name_display'},
      { text: 'Status', value: 'status' }
    ]
  }),
  methods: {
    openInquiry (item) {
      this.$router.push({ name: 'InquiryOverview', params: { id: item.id } })
    }
  },
  components: {
    'wc-div': WCDivisionNAI,
    'wc-estimate-generated': WCEstimateGenerated,
    'wc-archived': WCArchivedChip
  }
}
</script>